import React from "react";
import { MdAdd } from "react-icons/md";
import { Button } from "@material-ui/core";
import DragDropList from "../DragDropList";
import RowPlanConfig from "./Row/row";
import "./styles.scss";

export default function PlanConfigComponent(props) {
  const {
    valueGeneral,
    onChangeGeneral,
    onClickDeleteGeneral,
    onClickUp,
    onClickDown,
    onClickGeneral,
    onDragDrop,
    onChecked,
    currentStep,
    FeedsConfigField,
    btnAddConfigDataOuput,
    HandleAddConfigInputData,
    btnDeleteOuputConfig,
    btnDeleteInput,
    btnDownInput,
    btnUpInput,
    btnDownOutput,
    btnUpOutput, 
    onClickCopy
  } = props;

  const arrayItems = valueGeneral.map((item, index) => ({
    id: `${index}`,
    content: (
      <RowPlanConfig
        key={index}
        index={index}
        value={item}
        onChange={onChangeGeneral}
        onClickDelete={onClickDeleteGeneral}
        onClickUp={onClickUp}
        onClickDown={onClickDown}
        onChecked={onChecked}
        currentStep={currentStep}
        FeedsConfigField={FeedsConfigField}
        btnAddConfigDataOuput={btnAddConfigDataOuput}
        HandleAddConfigInputData={HandleAddConfigInputData}
        btnDeleteOuputConfig={btnDeleteOuputConfig}
        btnDeleteInput={btnDeleteInput}
        btnDownInput={btnDownInput}
        btnUpInput={btnUpInput}
        btnDownOutput={btnDownOutput}
        btnUpOutput={btnUpOutput}
        onClickCopy={onClickCopy}
      />
    ),
  }));

  return (
    <div className="plan-config col-md-12">
      {/* //     {props.value && props.value.map((item, index) => {
    //         return <RowPlanConfig key={index} index={index} value={item} onChange={props.onChange} onClickDelete={props.onClickDelete} onClickUp={props.onClickUp} onClickDown={props.onClickDown} />
    //     })} */}
      <DragDropList items={arrayItems} onDragDrop={onDragDrop} type="General"></DragDropList>
      <div className="row addConfigData">
        <Button
          variant="contained"
          className="btn-next"
          startIcon={<MdAdd />}
          onClick={onClickGeneral}
        >
          Thêm
        </Button>
      </div>
    </div>
  );
}
